export default {
  goToPlatform: 'Ir a la Plataforma'
}
